export const forgotPasswordEn = {};

export const forgotPasswordFr = {};
